import { createSlice } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

const BANKING_URL = `${process.env.REACT_APP_BACKEND_URL}/bankingAccount`;

const initialState = {
  isLoading: false,
  error: null,
  bankingAccounts: [],
  bankingAccount: null,
  page: 1,
  limit: 10,
  totalPages: 0,
  totalResults: 0,
};

const slice = createSlice({
  name: "accountsBanking",
  initialState,
  reducers: {
    startLoading(state) { state.isLoading = true; state.error = null; },
    hasError(state, action) { state.isLoading = false; state.error = action.payload; },
    getManySuccess(state, action) {
      const payload = action.payload || {};
      state.isLoading = false;
      state.bankingAccounts = payload.results || payload.data?.results || (Array.isArray(payload) ? payload : []);
      state.page = payload.page || payload.data?.page || 1;
      state.limit = payload.limit || payload.data?.limit || 10;
      state.totalPages = payload.totalPages || payload.data?.totalPages || 0;
      state.totalResults = payload.totalResults || payload.data?.totalResults || state.bankingAccounts.length;
    },
    getOneSuccess(state, action) { state.isLoading = false; state.bankingAccount = action.payload?.data || action.payload; },
    clearBankingAccount(state) { state.bankingAccount = null; state.error = null; },
  },
});

export default slice.reducer;

export function getAccountsBankingAccounts({ franchiseId, warehouseId, page = 1, limit = 10 }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(BANKING_URL, { params: { franchiseId, warehouseId, page, limit } });
      dispatch(slice.actions.getManySuccess(response.data));
      return response.data;
    } catch (error) { dispatch(slice.actions.hasError(error)); throw error; }
  };
}

export function getAccountsBankingAccount(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try { const response = await axios.get(`${BANKING_URL}/${id}`); dispatch(slice.actions.getOneSuccess(response.data)); return response.data; }
    catch (error) { dispatch(slice.actions.hasError(error)); throw error; }
  };
}

export function createAccountsBankingAccount(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try { const response = await axios.post(BANKING_URL, data); dispatch(slice.actions.getOneSuccess(response.data)); return response.data; }
    catch (error) { dispatch(slice.actions.hasError(error)); throw error; }
  };
}

export function updateAccountsBankingAccount(id, data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try { const response = await axios.patch(`${BANKING_URL}/${id}`, data); dispatch(slice.actions.getOneSuccess(response.data)); return response.data; }
    catch (error) { dispatch(slice.actions.hasError(error)); throw error; }
  };
}

export const { clearBankingAccount } = slice.actions;
